import { PROPERTY_STATE } from './constants'

export const getIsFetching = state => state[PROPERTY_STATE].isFetching
export const getProperty = state => state[PROPERTY_STATE].property
